
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";
import { formatarMoedaBrasileira } from "../../../../utils/formatarMoedaBrasileira";

export default function ResumoDepartamento({ data, loading, filtrar, alterarDepartamento }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [valoresNF, setValoresNF] = useState([]);

  useEffect(() => {
    if (data.resultadoSomaDTO?.porSetor) {
      const setores = Object.keys(data.resultadoSomaDTO.porSetor);
      const valores = Object.values(data.resultadoSomaDTO.porSetor);
      const valoresFormatados = valores.map((item) => item || "");

      setLabels(setores);
      setValoresNF(valoresFormatados);

      setChartOptions({
        chart: {
          type: "pie",
          toolbar: { show: true },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const index = config.dataPointIndex;
              const label = setores[index];
              alterarDepartamento(label);
            }
          }
        },
        labels: setores,
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        tooltip: {
          y: {
            formatter: (value, { seriesIndex }) => {
              const valorNF = valoresNF[seriesIndex] || "";
              return `Valor Gasto: R$ ${formatarMoedaBrasileira(valorNF)}`;
            }
          }
        },
        stroke: {
          show: false,
          width: 0
        },
        colors: [
          "#64748B",
          "#F97316",
          "#14B8A6",
          "#3B82F6",
          "#f4f801ff",
          "#f016a7ff",
          "#c5c222ff"
        ]
      });

      setChartSeries(valores);
    } else {
      setChartSeries([]);
    }
  }, [data, filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1 lg:min-h-[423px]">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Departamento
      </h3>
      <label className="text-muted-foreground text-sm">
        Comparativo de solicitações abertas e concluídas por departamento.
      </label>
   
        {!loading ? (
          data.solicitacoes.length > 0 && chartSeries.length > 0 ? (
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="pie"
              height={280}
            />
          ) : (
            "Não existem dados disponíveis para o intervalo selecionado."
          )
        ) : (
          <Loading />
        )}
     
    </div>
  );
}
